/* eslint-disable */

import autocomplete from 'autocomplete.js';
import A11yDialog from 'a11y-dialog';

/**
 * Nur für das Backend.
 */
const backendOverlaySelector = {
    /**
     * Lädt den Inhalt des Overlays
     * @param contentRoute
     * @returns {Promise<string>}
     */
    async loadOverlayContent(contentRoute) {
        try {
            const response = await fetch(contentRoute);
            return await response.text();
        } catch (err) {
            return '<div class="overlay__loading">Es ist ein Fehler aufgetreten.</div>';
        }
    },

    /**
     * Gibt die Lademeldung zurück
     * @returns {string}
     */
    overlayLoadingContent() {
        return '<div class="overlay__loading">Einen Moment bitte &hellip;</div>';
    },

    initAutoComplete() {
        const autocompleteElements = document.querySelectorAll('.js-autocomplete');
        autocompleteElements.forEach(function(autocompleteElement) {
            autocomplete(autocompleteElement, {
                hint:false,
                cache:false,
                openOnFocus:true,
                minLength:0
            }, [
                {
                    source: async (query, callback) => {
                        let url = Chronoto.routes.overlaySelectorSearch + '?q=' + autocompleteElement.value;
                        url += '&what=' + autocompleteElement.getAttribute('data-what');
                        if (autocompleteElement.hasAttribute('data-restrict-brand')) {
                            url += '&restrictBrand=' + autocompleteElement.getAttribute('data-restrict-brand');
                        }
                        if (autocompleteElement.hasAttribute('data-restrict-family')) {
                            url += '&restrictFamily=' + autocompleteElement.getAttribute('data-restrict-family');
                        }
                        if (autocompleteElement.hasAttribute('data-restrict-merchant')) {
                            url += '&restrictMerchant=' + autocompleteElement.getAttribute('data-restrict-merchant');
                        }

                        const source = await fetch(url);
                        callback(await source.json());
                    },
                    displayKey: 'name',
                    templates: {
                        suggestion: function(suggestion) {
                            return suggestion.name;
                        }
                    }
                }
            ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
                const targetInputSelectors = autocompleteElement.getAttribute('data-target').split(',');
                if (autocompleteElement.hasAttribute('data-target-attribute')) {
                    targetInputSelectors.forEach(function (targetInputSelector) {
                        document
                            .querySelector(targetInputSelector)
                            .setAttribute(
                                autocompleteElement.getAttribute('data-target-attribute'),
                                suggestion.id
                            );
                        document.querySelector(targetInputSelector).value = '';
                    });

                    document.querySelector(targetInputSelectors[0]).focus();
                } else {
                    document.querySelector(targetInputSelectors[0]).value = suggestion.id;
                    document.querySelector(targetInputSelectors[0] + '_display').innerHTML = suggestion.display;
                    backendOverlaySelector.dialog.hide();
                }
            });
        });
    },

    init() {
        const overlayElement = document.getElementById('js-overlay');
        if (overlayElement) {
            const main = document.querySelector('main');
            this.dialog = new A11yDialog(overlayElement, main);
            const contentWrapper = document.querySelector('.js-overlay-content');

            this.dialog.on('show', (overlay, event) => {
                // Entfernt Workaround, dass der Backdrop initial nicht aufflackert
                overlay.classList.remove('is-loading');

                // Holt die Route zur Datenquelle aus dem Data-Attribut
                let contentRoute = event.getAttribute('data-content-route') + '?';
                const entity = event.getAttribute('data-entity');
                if (entity) {
                    contentRoute += '&id=' + entity;
                }
                const restrictBrand = event.getAttribute('data-restrict-brand');
                if (restrictBrand) {
                    contentRoute += '&restrictBrand=' + restrictBrand;
                }
                const restrictFamily = event.getAttribute('data-restrict-family');
                if (restrictFamily) {
                    contentRoute += '&restrictFamily=' + restrictFamily;
                }
                const restrictMerchant = event.getAttribute('data-restrict-merchant');
                if (restrictMerchant) {
                    contentRoute += '&restrictMerchant=' + restrictMerchant;
                }

                // Setzt sicherheitshalber die Lademeldung
                contentWrapper.innerHTML = backendOverlaySelector.overlayLoadingContent();

                // Lädt den Inhalt
                backendOverlaySelector.loadOverlayContent(contentRoute).then((response) => {
                    contentWrapper.innerHTML = response;
                    backendOverlaySelector.initAutoComplete();
                });
            });

            // Beim Schließen des Overlays wird der Inhalt wieder durch die Lademeldung ersetzt
            this.dialog.on('hide', () => {
                contentWrapper.innerHTML = backendOverlaySelector.overlayLoadingContent();
            });

            // Damit ich ein onclick für die per JS nachgeladenen Formularelemente machen kann
            window.chronotoDialog = this.dialog;

            document.addEventListener('click', function (event) {
                if (!event.target.matches('.js-overlay-selector-clear')) {
                    return;
                }
                event.preventDefault();

                const targetSelector = '#' + event.target.getAttribute('data-target');
                document.querySelector(targetSelector).value = '';
                document.querySelector(targetSelector + '_display').innerHTML = '';
            }, false);

        }
    },
};

export default backendOverlaySelector;
